// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1asWc","detailsBorder":"styles_detailsBorder__3T3nO"};